import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Search"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.4998 21.4425L16.8373 15.75C19.6493 12.3571 19.2985 7.35327 16.0405 4.38604C12.7825 1.4188 7.76774 1.53585 4.65173 4.65185C1.53573 7.76786 1.41868 12.7826 4.38591 16.0406C7.35315 19.2986 12.357 19.6495 15.7498 16.8375L21.4423 22.5L22.4998 21.4425ZM3.7498 10.5C3.7498 6.77206 6.77188 3.74998 10.4998 3.74998C14.2277 3.74998 17.2498 6.77206 17.2498 10.5C17.2498 14.2279 14.2277 17.25 10.4998 17.25C6.77188 17.25 3.7498 14.2279 3.7498 10.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Search.vue"]]);
